export default __webpack_public_path__ + "static/media/icon-validate-off.4f2510bd.svg";